import { createSlice } from "@reduxjs/toolkit";

const announcement = {
  adInfo: {},
  adCategory: {},
  mosque: {},
  id: "",
};

const initialState = announcement;

export const announcementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {
    setAnnouncement: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        adInfo: payload,
        adCategory: payload.category,
        mosque: payload.mosque,
        id: payload.id,
      };
    },
  },
});

export const { setAnnouncement } = announcementSlice.actions;

export default announcementSlice.reducer;
